import { render, staticRenderFns } from "./YesNoView.vue?vue&type=template&id=bf2a757c&scoped=true&"
import script from "./YesNoView.vue?vue&type=script&lang=js&"
export * from "./YesNoView.vue?vue&type=script&lang=js&"
import style0 from "./YesNoView.vue?vue&type=style&index=0&id=bf2a757c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf2a757c",
  null
  
)

export default component.exports